import { parseOptionalNonNegativeInt } from '../../parse-optional-non-negative-int.js';
import { parseOptionalNonNegativeNumber } from '../../parse-optional-non-negative-number.js';
import { toNewContactsInput } from '../contact/to-new-contacts-input.js';
import { toCreateVendorAddressPairInput } from '../vendor-address/to-create-vendor-address-pair-input.js';
export function toCreateVendorInput(values, { address, contacts }) {
    const creditLimit = parseOptionalNonNegativeNumber(values.creditLimit, 'Credit limit');
    const leadTime = parseOptionalNonNegativeInt(values.leadTime, 'Lead time');
    const minOrderAmount = parseOptionalNonNegativeNumber(values.minOrderAmount, 'Min order amount');
    return {
        name: values.name.trim(),
        url: values.url.trim() || undefined,
        note: values.note.trim() || undefined,
        email: values.email?.trim() || undefined,
        phone: values.phone.trim() || undefined,
        currencyId: values.currencyId || undefined,
        paymentTermsId: values.paymentTermsId,
        shipTermsId: values.shipTermsId,
        carrierId: values.carrierId,
        creditLimit: typeof creditLimit === 'number' ? creditLimit : undefined,
        leadTime: typeof leadTime === 'number' ? leadTime : undefined,
        minOrderAmount: typeof minOrderAmount === 'number' ? minOrderAmount : undefined,
        address: address ? toCreateVendorAddressPairInput(address) : undefined,
        contacts: toNewContactsInput(contacts),
    };
}
//# sourceMappingURL=create-mapper.js.map